import { Routes } from '@angular/router';
import { roleGuard } from './guards/role.guard';
import { authGuard } from './guards/auth.guard';
import { dashboardGuard } from './guards/dashboard.guard';

export const routes: Routes = [

  {
    path: 'privacy-policy',
    title: 'Privacy Policy | Kaparking',
    data: { document: 'privacy' },
    loadComponent: () => import('./pages/legal/legal-document/legal-document.component').then(m => m.LegalDocumentComponent)
  },
  {
    path: 'terms-and-conditions',
    title: 'Terms & Conditions | Kaparking',
    data: { document: 'terms' },
    loadComponent: () => import('./pages/legal/legal-document/legal-document.component').then(m => m.LegalDocumentComponent)
  },

  {
    path: '',
    loadComponent: () => import('./layouts/backend-layout/backend-layout.component').then(m => m.BackendLayoutComponent),
    canActivate: [authGuard],
    children: [
      { path: 'super-admin', data: { roles: ['super-admin'] }, loadChildren: () => import('./pages/backend/super-admin/super-admin.routes').then(m => m.superAdminRoutes) },
      { path: 'council', data: { roles: ['council'] }, loadChildren: () => import('./pages/backend/council/council.routes').then(m => m.councilRoutes) },
      { path: 'crc', data: { roles: ['crc'] }, loadChildren: () => import('./pages/backend/crc/crc.routes').then(m => m.crcRoutes) },
      { path: 'access-denied', loadComponent: () => import('./pages/backend/access-denied.component').then(m => m.AccessDeniedComponent) },
      { path: '', pathMatch: 'full', canActivate: [dashboardGuard], children: [] }
    ]
  },
  {
    path: 'auth',
    loadComponent: () => import('./layouts/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/auth/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'reset',
        loadComponent: () => import('./pages/auth/reset/reset.component').then(m => m.ResetComponent)
      },
      {
        path: 'otp',
        loadComponent: () => import('./pages/auth/otp/otp.component').then(m => m.OtpComponent)
      },
      {
        path: 'set-password',
        loadComponent: () => import('./pages/auth/set-password/set-password.component').then(m => m.SetPasswordComponent)
      }
    ]
  }
];
